import React from 'react';

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidCatch(error) {
    const { onError } = this.props;
    console.error('Unexpected Error', error);
    this.setState({ hasError: true });
    onError();
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;
    if (hasError) {
      return null;
    }

    return children;
  }
}
